const inputExtar = {
  //maxlength: 50,
  placeholder: "请输入内容"
}
const inputNumberExtar = {
  precision: 0, // 精度 保留多少位小数
  // min: -Infinity, // 最小值
  // max: Infinity, // 最大值
}
const common = {
  isRequired: false,
  isTableHead: false,
  isSearch: false,
  refFieldFlag: "", // 题目关联 标识
  refRelation: "", // 题目关联 关系
  refFieldValue: "", // 题目关联 值
  isError: false, // 校验使用
  errorText: "",
  refText: "" // 关联显示文字
}
const fieldList = [
  { fieldType: 1, fieldName: "单行文本", ...common, extar: { ...inputExtar }  },
  { fieldType: 2, fieldName: "多行文本", ...common,  extar: { ...inputExtar } },
  { fieldType: 3, fieldName: "数字输入框", ...common, extar: { ...inputNumberExtar } },
  { fieldType: 4, fieldName: "单选", ...common, selectTypes: [], extar: {} },
  { fieldType: 5, fieldName: "多选", ...common, selectTypes: [], extar: {} },
  { fieldType: 6, fieldName: "下拉单选", ...common, selectTypes: [], extar: {} },
  { fieldType: 7, fieldName: "下拉多选", ...common, selectTypes: [], extar: {} },
  { fieldType: 8, fieldName: "日期", ...common, extar: {} },
  { fieldType: 9, fieldName: "时间", ...common, extar: {} },
  { fieldType: 10, fieldName: "文件上传", ...common, fileTypes: ["pdf", "png"], extar: {} },
  // { fieldType: 11, fieldName: "提醒", isRequired: false, extar: {} },
]
export default fieldList;